module.exports = __webpack_public_path__ + "img/africaMap.c71e6b32.png";